<section class="wallet-page">
    <div class="wallet-container">

        <!-- Balance hero -->
        <div class="balance-hero">
            <div class="bh-left">
                <span class="bh-icon">
                    <img src="/assets/image/wallet.svg" alt="wallet">
                </span>
                <div class="bh-info">
                    <p class="bh-label">Current Wallet Balance</p>
                    <p class="bh-amount">{{gS.currencySign}} {{totalWalletAmount}}</p>
                </div>
            </div>
            <div class="bh-badge">
                <i class="fa-solid fa-shield-halved"></i>
                <span>100% Secure Payments</span>
            </div>
        </div>

        <div class="wallet-grid">

            <!-- Left: choose funds -->
            <div class="wallet-left">
                <div class="funds-card">
                    <div class="fc-head">
                        <h1 class="section-title">Choose funds to add</h1>
                        <p class="section-sub">Pick a quick amount or enter your own to top up instantly.</p>
                    </div>

                    <div class="amount-input-wrap" [class.invalid]="values<=0 && amount<=0">
                        <span class="cur">{{gS.currencySign}}</span>
                        <input type="number" placeholder="Enter any amount to add" class="amount"
                            [(ngModel)]="amount" (keyup)="amountAdd()">
                    </div>

                    <p class="chip-label">Suggested amounts</p>
                    <div class="chip-grid">
                        <div class="chip-cell" *ngFor="let item of walletAmount;let i=index">
                            <button type="button" (click)="amountClick(item,i)"
                                class="amt-chip voiltrecharg avtive {{i==activeIndex?'wallet-active':''}}"
                                [ngClass]="condition">
                                <span class="chip-amt">{{gS.currencySign}} {{item.amount}}</span>
                                <span class="chip-extra like redco intro" *ngIf="item.discount">
                                    <span class="redco">+{{gS.currencySign}}{{((item.amount)*(item.discount))/100}} extra</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right: promo + summary -->
            <aside class="wallet-right secondrowclass">
                <div class="promo card p-4 promo">
                    <h2 class="card-title">Have a promo code?</h2>
                    <div class="promo-btn">
                        <input [(ngModel)]="couponCode" type="text" placeholder="Enter coupon code"
                            (keyup)="changeCoupon()">
                        <a href="javascript:void(0)" (click)="applyCouponCode()" [ngClass]="applyBtn">{{applyBtn}}</a>
                    </div>
                </div>

                <div class="payment card p-4 payment">
                    <h2 class="card-title">Payment Summary</h2>

                    <div class="sum-row">
                        <span class="sum-label">Recharge Amount</span>
                        <span class="sum-value">{{gS.currencySign}} {{amount}}</span>
                    </div>

                    <div class="sum-row" *ngIf="gS.indiaZone">
                        <span class="sum-label">Taxes (GST&#64;18%)</span>
                        <span class="sum-value">{{gS.currencySign}} {{gst}}</span>
                    </div>

                    <div class="sum-row">
                        <span class="sum-label">Total Payable Amount</span>
                        <span class="sum-value">{{gS.currencySign}} {{totalAmount}}</span>
                    </div>

                    <div class="sum-row cashback" *ngIf="discount>0">
                        <span class="sum-label">Cashback</span>
                        <span class="sum-value">+ {{gS.currencySign}} {{discount}}</span>
                    </div>

                    <div class="sum-divider"></div>

                    <div class="sum-row total">
                        <span class="sum-label">You'll receive in wallet</span>
                        <span class="sum-value">{{gS.currencySign}} {{amount+discount}}</span>
                    </div>

                    <p class="terms">By proceeding to pay, you accept all the
                        <a routerLink="/terms"><span>terms and conditions</span></a> and
                        <a routerLink="/privacy"><span>privacy policy</span></a>.
                    </p>

                    <button class="pay-btn btn btn-info2" (click)="createRzpayOrder()" [ngClass]="btn">
                        Proceed to Pay
                        <span class="pay-amt" *ngIf="totalAmount>0">· {{gS.currencySign}} {{totalAmount}}</span>
                    </button>
                </div>
            </aside>
        </div>

        <!-- Payment partners -->
        <div class="partners">
            <h2 class="partners-title">Payment processing partner</h2>
            <div class="partners-top">
                <img class="rzp" src="/assets/image/razorpay.svg" alt="Razorpay">
                <img class="shield" src="/assets/image/security-shield.svg" alt="Secure">
            </div>
            <div class="partners-logos">
                <img src="/assets/image/pngwing.svg" alt="">
                <img src="/assets/image/master-card.svg" alt="Mastercard">
                <img src="/assets/image/Visa_Logo.svg" alt="Visa">
                <img src="/assets/image/rupay-Logo.svg" alt="RuPay">
                <img src="/assets/image/netbanking.svg" alt="Net Banking">
            </div>
        </div>
    </div>
</section>


<!-- Modal for mobile -->
<div class="bottom-modal" *ngIf="showModal && isMobileScreen">
    <div class="modal-content">
        <div class="close-btn" (click)="closeModal()">×</div>
        <div class="payment">
            <h2 class="card-title">Payment Summary</h2>

            <div class="sum-row">
                <span class="sum-label">Recharge Amount</span>
                <span class="sum-value">{{ gS.currencySign }} {{ amount }}</span>
            </div>

            <div class="sum-row" *ngIf="gS.indiaZone">
                <span class="sum-label">Taxes (GST&#64;18%)</span>
                <span class="sum-value">{{ gS.currencySign }} {{ gst }}</span>
            </div>

            <div class="sum-row">
                <span class="sum-label">Total Payable Amount</span>
                <span class="sum-value">{{ gS.currencySign }} {{ totalAmount }}</span>
            </div>

            <div class="sum-row cashback" *ngIf="discount > 0">
                <span class="sum-label">Cashback</span>
                <span class="sum-value">+ {{ gS.currencySign }} {{ discount }}</span>
            </div>

            <div class="sum-divider"></div>

            <div class="sum-row total">
                <span class="sum-label">You'll receive in wallet</span>
                <span class="sum-value">{{ gS.currencySign }} {{ amount + discount }}</span>
            </div>

            <div class="promo">
                <h2 class="card-title">Have a promo code?</h2>
                <div class="promo-btn">
                    <input [(ngModel)]="couponCode" type="text" placeholder="Enter coupon code"
                        (keyup)="changeCoupon()">
                    <a href="javascript:void(0)" (click)="applyCouponCode()" [ngClass]="applyBtn">{{applyBtn}}</a>
                </div>
            </div>

            <button class="pay-btn btn btn-info2" (click)="createRzpayOrder()" [ngClass]="btn">Proceed to Pay</button>
        </div>
    </div>
</div>


<app-active-call-chat-strip *ngIf="gS.showChatStrip"></app-active-call-chat-strip>
